import { useEffect } from "react";

/**
 * Tasks Module v1.0 § 7.4 — Cmd/Ctrl+Shift+T opens the Quick Add modal.
 * Deliberately NOT Cmd+K (the global search shortcut). Listens at the
 * window level so it works regardless of focus, but ignores the event
 * when the user is mid-IME composition or holding a different modifier
 * combo.
 */
export function useQuickAddShortcut(onOpen: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if (e.isComposing) return;
      const meta = e.metaKey || e.ctrlKey;
      if (meta && e.shiftKey && (e.key === "T" || e.key === "t")) {
        e.preventDefault();
        onOpen();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [enabled, onOpen]);
}
